export const mapPadding = () => {
  // On mobile the map is centered, on desktop the map is overlayn with a
  // result list on the left side. Use this value to offset the map accordingly.
  if (window.innerWidth < 1000) {
    return [0, 20];
  }
  return [500, 20];
};
